// Technical cross-section of a countertop edge: polished stone slab on a cabinet line,
// drawn from the profile path (10 units = 1 cm). Fill and stroke follow the site palette.
export const EdgeSection = ({ profile, className = "", large = false }) => {
  const id = `edge-${profile.slug}${large ? "-lg" : ""}`;
  const bottom = profile.type === "laminated" ? 100 : 70;
  return (
    <svg
      viewBox="0 22 200 100"
      className={className}
      role="img"
      aria-label={`${profile.name} edge profile`}
      data-testid={`edge-section-${profile.slug}`}
    >
      <defs>
        <linearGradient id={`${id}-stone`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#e8e2d6" />
          <stop offset="0.35" stopColor="#d6cdbd" />
          <stop offset="1" stopColor="#bfb39f" />
        </linearGradient>
        <linearGradient id={`${id}-sheen`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset="0.55" stopColor="#fff" stopOpacity="0.55" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <pattern
          id={`${id}-vein`}
          width="200"
          height="150"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M-10,52 C40,44 70,66 120,56 S170,48 210,60"
            fill="none"
            stroke="#8f8471"
            strokeOpacity="0.28"
            strokeWidth="1.2"
          />
          <path
            d="M-10,84 C50,76 90,96 140,86 S190,80 210,92"
            fill="none"
            stroke="#8f8471"
            strokeOpacity="0.18"
            strokeWidth="0.9"
          />
        </pattern>
        <clipPath id={`${id}-clip`}>
          <path d={profile.path} />
        </clipPath>
      </defs>

      {/* cabinet line + reveal under the counter */}
      <rect
        x="0"
        y={bottom + 6}
        width="112"
        height={150 - bottom - 6}
        style={{ fill: "var(--s-edge-cab, #efece6)" }}
      />
      <line
        x1="0"
        y1={bottom + 6}
        x2="112"
        y2={bottom + 6}
        style={{ stroke: "var(--s-edge-cab-line, #d5cfc4)" }}
        strokeWidth="1"
      />

      {/* stone */}
      <path d={profile.path} fill={`url(#${id}-stone)`} />
      <rect
        x="0"
        y="0"
        width="200"
        height="150"
        fill={`url(#${id}-vein)`}
        clipPath={`url(#${id}-clip)`}
      />
      <rect
        x="0"
        y="40"
        width="150"
        height="4"
        fill={`url(#${id}-sheen)`}
        clipPath={`url(#${id}-clip)`}
      />
      {profile.seam && (
        <path
          d={profile.seam}
          fill="none"
          stroke="#7a6e5d"
          strokeOpacity="0.6"
          strokeWidth="0.8"
          strokeDasharray="2 2"
        />
      )}
      <path
        d={profile.path}
        fill="none"
        stroke="#2e2c29"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />

      {/* thickness marker */}
      <line
        x1="172"
        y1="40"
        x2="172"
        y2={bottom}
        stroke="#9a948b"
        strokeWidth="0.8"
      />
      <line
        x1="168"
        y1="40"
        x2="176"
        y2="40"
        stroke="#9a948b"
        strokeWidth="0.8"
      />
      <line
        x1="168"
        y1={bottom}
        x2="176"
        y2={bottom}
        stroke="#9a948b"
        strokeWidth="0.8"
      />
      <text
        x="180"
        y={(40 + bottom) / 2 + 3}
        fontSize="8"
        fontFamily="ui-sans-serif, system-ui"
        fill="#6e6862"
      >
        {profile.type === "laminated" ? "6 cm" : "3 cm"}
      </text>
    </svg>
  );
};
